import React, { useState } from 'react';
import BubbleButton, { BubbleButtonProps } from './BubbleButton';

export interface BubbleCollapsibleSectionProps extends BubbleButtonProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function BubbleCollapsibleSection({
  title,
  children,
  defaultOpen = false,
  className,
  ...buttonProps
}: BubbleCollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className={`transition-all duration-100 ${className}`}>
      <div className="flex justify-between items-center w-full">
        <BubbleButton
          iconSuffix={isOpen ? 'chevron-up' : 'chevron-down'}
          {...buttonProps}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="bubble-fg-label">{title}</span>
        </BubbleButton>
      </div>

      {isOpen && <div className="p-4">{children}</div>}
    </div>
  );
}

export default BubbleCollapsibleSection;
